import { SxProps, Theme } from '@mui/material/styles';

const MOBILE_BREAKPOINT = '@media (max-width: 640px)';
const CARD_WIDTH = '185px';
const MOBILE_CARD_WIDTH = 'calc((100vw - 28px) / 2.5)';

export const sponsoredRootSX: SxProps<Theme> = {
	position: 'relative',
	maxWidth: '1280px',
	margin: '0 auto 20px',
	padding: '14px 14px 18px',
	background: '#f5f5f5',
	boxSizing: 'border-box',
	color: '#0f1111',
	width: '100%',
	[MOBILE_BREAKPOINT]: {
		width: '100vw',
		maxWidth: '100vw',
		marginLeft: 'calc(50% - 50vw)',
		marginRight: 'calc(50% - 50vw)',
		padding: '10px 10px 24px',
	},
};

export const sponsoredHeaderSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
	mb: '12px',
	[MOBILE_BREAKPOINT]: {
		gap: '8px',
		mb: '8px',
	},
};

export const sponsoredLogoSX: SxProps<Theme> = {
	flexShrink: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '44px',
	height: '44px',
	background: '#fff',
	overflow: 'hidden',
	'& img': {
		display: 'block',
		width: '100%',
		height: '100%',
		objectFit: 'contain',
	},
	[MOBILE_BREAKPOINT]: {
		width: '50px',
		height: '50px',
	},
};

export const sponsoredRowSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'stretch',
	gap: '4px',
	background: '#fff',
	overflow: 'hidden',
	[MOBILE_BREAKPOINT]: {
		overflowX: 'auto',
		scrollSnapType: 'x mandatory',
		WebkitOverflowScrolling: 'touch',
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': { display: 'none' },
	},
};

export const sponsoredHeroSX: SxProps<Theme> = {
	position: 'relative',
	flex: `0 0 ${CARD_WIDTH}`,
	width: CARD_WIDTH,
	alignSelf: 'stretch',
	background: '#e8e8e8',
	overflow: 'hidden',
	borderRight: '1px solid #e0e0e0',
	'& video, & img': {
		display: 'block',
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		background: '#e8e8e8',
	},
	[MOBILE_BREAKPOINT]: {
		flex: `0 0 ${MOBILE_CARD_WIDTH}`,
		width: MOBILE_CARD_WIDTH,
		scrollSnapAlign: 'start',
	},
};

export const sponsoredProductsSX: SxProps<Theme> = {
	display: 'flex',
	flex: '1 1 auto',
	gap: '4px',
	minWidth: 0,
	overflowX: 'auto',
	scrollbarWidth: 'none',
	width: '1px',
	'&::-webkit-scrollbar': { display: 'none' },
	[MOBILE_BREAKPOINT]: {
		flex: '0 0 auto',
		minWidth: 0,
		overflow: 'visible',
	},
};

export const sponsoredProductSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	flex: `0 0 ${CARD_WIDTH}`,
	width: CARD_WIDTH,
	borderLeft: '1px solid #e0e0e0',
	borderRight: '1px solid #e0e0e0',
	borderBottom: '1px solid #e0e0e0',
	textDecoration: 'none',
	color: 'inherit',
	background: '#fff',
	overflow: 'hidden',
	'&:hover, &:focus-visible': { background: '#fafafa' },
	'&:focus-visible': { outline: '2px solid #0f1111', outlineOffset: '-2px' },
	[MOBILE_BREAKPOINT]: {
		flex: `0 0 ${MOBILE_CARD_WIDTH}`,
		width: MOBILE_CARD_WIDTH,
		scrollSnapAlign: 'start',
	},
};

export const sponsoredProductImageSX: SxProps<Theme> = {
	position: 'relative',
	aspectRatio: '1 / 1',
	background: '#e8e8e8',
	overflow: 'hidden',
	'& img': {
		display: 'block',
		width: '100%',
		height: '100%',
		objectFit: 'contain',
		boxSizing: 'border-box',
	},
};

export const sponsoredProductInfoSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
	padding: '10px 10px 12px',
	flex: 1,
	background: '#fff',
	[MOBILE_BREAKPOINT]: {
		padding: '8px 8px 10px',
		gap: '4px',
	},
};

export const sponsoredSkeletonSX: SxProps<Theme> = {
	flex: `0 0 ${CARD_WIDTH}`,
	width: CARD_WIDTH,
	[MOBILE_BREAKPOINT]: {
		flex: `0 0 ${MOBILE_CARD_WIDTH}`,
		width: MOBILE_CARD_WIDTH,
	},
};
